/***
 * Created on 2023/12/22
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import TextInput from "../common/form/text_input";
import {useMutation} from "@tanstack/react-query";
import Captcha from "../common/captcha";
import {useOnChange} from "common/Hook";
import {apiPost, executeGrecaptcha} from "../../service/api";
import {getErrorMessage} from 'common/ServiceCommon';


function SendActivationEmail(props) {
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState();

    const getEmail = () => {
        const url = new URL(location.href)
        const qid = url.searchParams.get('qid');
        return qid || '';
    }

    const {values, setValues, onChange} = useOnChange({
        email: getEmail(),
        captcha: ''
    });

    const sendEmailMutation = useMutation({
        mutationFn: async (data) => await apiPost('/resend_activation_email', data),
        onSuccess: data => {
            location.href = '/signup#email_activation'
        },
        onError: (error, variables, context) => {
            setErrorMessage(getErrorMessage(t, error.cause?.code));
        }
    });

    const sendEmail = async () => {
        setErrorMessage(null);
        await executeGrecaptcha("RESEND_ACTIVATION_EMAIL", async (recaptcha_token) => {
            const data = {
                ...values,
                recaptcha_token
            }
            await sendEmailMutation.mutateAsync(data);
        });
    }

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Send activation email@')}</div>
            <div className="common-page-body">
                <p>{t('@Please enter myQNAPcloud ID in the form and submit it. An email will be sent to your registered email address with a link. Click the link to activate myQNAPcloud account.@')}</p>
                <div className="common-form-group">
                    <div className="comp-input">
                        <div className="input-field--modern">
                            <TextInput label={t('@Email@')} placeholder={t('@Email@')} name='email' value={values.email} onChange={onChange} required={true}/>
                        </div>
                    </div>
                    {errorMessage && <p className="text-error mt-10">{errorMessage}</p>}
                </div>

                <Captcha value={values.captcha} inputChangeHandler={onChange} resetValue={() => setValues(prev => ({...prev, captcha: ''}))}/>

                <p>
                    {t('@If you have not received the activation mail, please check the spam folder in your mail client first. We suggest to add myQNAPcloud announce email account no-reply@qnap.com to your contact list to avoid the email accidentally diverted to your spam folder.@')}
                </p>
            </div>

            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" onClick={sendEmail}>{t('@Submit@')}</button>
                </div>
            </div>
        </section>
    );
}

export default SendActivationEmail;